import BoardListSection from './BoardListSection';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from '@mui/material';
import { SIDEBAR_WIDTH } from 'Constants';
import { POPULAR_BOARDS_IDS } from 'PopularBoards';
import React from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import HtmlTooltip from 'tooltip/HtmlTooltip';

import {
  cloudBoardIDsAtom,
  isNewModalOpenAtom,
  localBoardIDsAtom,
} from 'state/recoilState';
import { selectUserName } from 'state/signInRecoilState';
import { isDev } from 'utils/utils';

function LeftPanel() {
  const setIsNewModalOpen = useSetRecoilState(isNewModalOpenAtom);
  const userName = useRecoilValue(selectUserName);
  const localBoardIDs = useRecoilValue(localBoardIDsAtom);
  const cloudBoardIDs = useRecoilValue(cloudBoardIDsAtom);

  return (
    <Box sx={{ width: SIDEBAR_WIDTH }}>
      {localBoardIDs.length === 0 && cloudBoardIDs.length === 0 && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            pt: 2,
            pb: 4,
          }}
        >
          <Box sx={{ pb: 1, width: 220 }}>
            <Typography align="center">
              You don't have any boards. Click the button to create one!
            </Typography>
          </Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setIsNewModalOpen(true)}
            startIcon={<AddIcon />}
          >
            New Board
          </Button>
        </Box>
      )}

      <BoardListSection
        boardIDs={localBoardIDs}
        name={isDev() ? 'Local Boards' : 'My Boards'}
        secondaryAction={
          isDev() && (
            <HtmlTooltip
              placement="right"
              title={
                <Card>
                  <CardHeader title="Local Boards"></CardHeader>
                  <CardContent>
                    <Typography>
                      Local boards are stored on your device by your browser.
                      They are not associated with a user or account, and will
                      not be synced across devices or browsers.
                      <br />
                      <br />
                      Sign in to sync boards across devices.
                    </Typography>
                  </CardContent>
                </Card>
              }
            >
              <InfoIcon sx={{ height: 24 }}></InfoIcon>
            </HtmlTooltip>
          )
        }
      />

      {userName && cloudBoardIDs && (
        <BoardListSection boardIDs={cloudBoardIDs} name={userName} />
      )}

      <BoardListSection boardIDs={POPULAR_BOARDS_IDS} name="Popular Boards" />
    </Box>
  );
}

export default React.memo(LeftPanel);
